import ReactDOM from 'react-dom';
import React,{ useState , useEffect, useRef, useLayoutEffect, useCallback } from "react";
import albumOptionsEvents from "../albums/components/album_options_events";
import { on } from "../../utils/events";
import { hideDropdownMenu, toggleElementById } from "../../utils/common_utils"

const GearIconInitialTransData = {
    hideShareClassName: photoOrg.history.historyState.pg === photoOrg.constants.SHARED_WITH_ME_ALBUM_VIEW ? "no-libshareic" : "",
    shareAlbumText: photoOrg.history.historyState.pg === photoOrg.constants.SHARED_WITH_ME_ALBUM_VIEW ? "" : photoOrg.translations.photos["share_album"],
    slideShowText: photoOrg.translations.photos["slideshow"],
    deleteAlbumText: photoOrg.history.historyState.pg === photoOrg.constants.SHARED_WITH_ME_ALBUM_VIEW ?photoOrg.translations.photos["albums_option"]["delete_album"] : photoOrg.translations.photos["delete_album_txt"]
}

const getInnerHeight = (elm) => {
    var computed = getComputedStyle(elm),
        padding = parseInt(computed.paddingTop) + parseInt(computed.paddingBottom);
  
    return elm.clientHeight - padding
  }

/* global photoOrg */
const AlbumsGearIconDropdown = () => {
    const [config] = useState(GearIconInitialTransData)
    const [adjustToolTip, setAdjustToolTipB] = useState(false);
    const [showDeleteOverlay, setShowDeleteOverlay] = useState(false);
    const [deleteConfirmationAlbumName, setDeleteConfirmationAlbumName] = useState("");
    const dropDownRef = useRef(null);
    const showBottomToolTip = useRef(true);
    const showTopToolTip = useRef(false);

    const setToolTip =  useCallback(({ detail }) => {
        setAdjustToolTipB(detail);
    },[]);

    useEffect(()=>{
        on("rsetToolTip",setToolTip);
    },[])

    useLayoutEffect(()=>{
        if(adjustToolTip && dropDownRef.current){
            const clickedDivPosition = document.getElementById(adjustToolTip.setToolTip).getBoundingClientRect();
            dropDownRef.current.style.width = 'auto';
            
            dropDownRef.current.classList.remove('drop-top');
            const albumOptionsInnerHeight = getInnerHeight(dropDownRef.current);
            //here 20 is number, for gear-icon height
            //check belowway of accessing DOM working or not
            var topLocation = clickedDivPosition.top + albumOptionsInnerHeight + 20;
            //for mobile we have to add.mobile footer height
            if(photoOrg.Util.isMobileLayout()){
                topLocation = topLocation + getInnerHeight(document.querySelector('.photo-Org .mobile-footer'));
            }
            var windowHeight = window.innerHeight;
            if(windowHeight < topLocation){
                dropDownRef.current.style.marginTop = -(albumOptionsInnerHeight + 60)+"px";
                dropDownRef.current.classList.add('drop-top');
                //showing the top pointer when dropdown displayed on top of tools button
                showBottomToolTip.current = false;
                showTopToolTip.current = true;
            }else{
                dropDownRef.current.style.marginTop = "";
                //showing the bottom pointer when dropdown displayed on bottom of tools button
                showBottomToolTip.current = true;
                showTopToolTip.current = false;
            }
            if(adjustToolTip.keyCode){
                photoOrg.photoLib.setFocusForDropdownElement(photoOrg.rdropDownMenuButtonObj, adjustToolTip.keyCode);
            }
            setAdjustToolTipB(false)
        }
    },[adjustToolTip])

    useEffect(()=>{
        if(showDeleteOverlay){
            $(document).foundation();
            $("#rdeleteConfirmation").foundation('reveal','open');
        }else{
            if($("#rdeleteConfirmation").hasClass("open")){
                $("#rdeleteConfirmation").foundation('reveal','close');
            }
        }
    },[showDeleteOverlay])
    
    const deleteAlbum = (e) => { 
        try{
            e.preventDefault();
            toggleElementById("loadingBar", "block");
            const sortCriteria = photoOrg.history.historyState.sc;
            const activeMenuElement = document.getElementsByClassName("menu_active")[0];
            let albumId = activeMenuElement.getAttribute("id");
            if(albumId.indexOf("album_") !== -1){
                albumId = albumId.split("_")[1];
            }
            const monthId =  activeMenuElement.closest(".asset-group").id;
            let key = monthId;
            if (sortCriteria !== "caption"){
                const monthNYear = monthId.split("_")
                key = monthNYear[1]+"-"+ ((parseInt(monthNYear[0]) + 1) < 10 ? ("0" + (parseInt(monthNYear[0]) + 1)) : (parseInt(monthNYear[0]) + 1))
            }
            
            albumOptionsEvents.deleteAlbum(albumId, key);
            setShowDeleteOverlay(false);
            
        }catch (e) {
            photoOrg.clientLogger.error({description: "LIBRARY:albums_view:deleteAlbum:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
        }
    }

    const openDeleteModel = (event)=>{
        event.preventDefault();
        let albumId = document.getElementsByClassName("menu_active")[0].getAttribute("id");
        if(albumId.indexOf("album_") !== -1){
            albumId = albumId.split("_")[1];
        }
        const albumModel = photoOrg.photoLib.albumModelList[albumId];
        photoOrg.Util.trackLinksAndButtons('Delete Album', photoOrg.constants.pageNames[photoOrg.history.historyState.pg],{'trackerId': "DELETE_ALBUM", 'trackerData':["aid:"+albumId]});
        //photoOrg.Util.trackLinksAndButtons('Delete Album Button',photoOrg.constants.pageNames[photoOrg.history.historyState.pg])
        setShowDeleteOverlay(true);
        setDeleteConfirmationAlbumName(photoOrg.translations.photos["action_container"]["delete_album_confirm"].replace("{albumName}",albumModel.caption))
        hideDropdownMenu();
    }

    const closeDeleteModel = (e) =>{
        e.preventDefault();
        setShowDeleteOverlay(false);
    }

    
    return (<>
        <ul role="menu" id="ralb-gearicon" exclude_for_small="true" ref={dropDownRef} className="f-dropdown">
            {
                (showBottomToolTip.current) ? (
                <li className="menu-position-bottom">
                    <span className="sf-pointer sf-pointer-bottom"></span>
                </li>)
                :null
            }
            

            <li role="none" className={`libshareic ${config.hideShareClassName}`} title={config.shareAlbumText} name="av_share_album" onClick={albumOptionsEvents.shareAlbum} onTouchStart={albumOptionsEvents.shareAlbum}>
               <a role="menuitem" tabIndex="-1" href="#" aria-label={ `${config.shareAlbumText} ${photoOrg.translations.photos["aria_label"]["opens_dialog"]}`}>
                    <span className="menu_icon icon-icon_share_photo"></span> 
                    { config.shareAlbumText}
               </a>
            </li>
            <li role="none" className="slideShow" style={{display: config.displaySlideShowOption}} name="av_slideshow"  onClick={albumOptionsEvents.openSlideshow} onTouchStart={albumOptionsEvents.openSlideshow}>
                <a role="menuitem" tabIndex="-1" href="javascript:void(0)" aria-label={`${config.slideShowText} ${photoOrg.translations.photos["aria_label"]["opens_dialog"]}`}>
                    {/* // onMouseUp={albumOptionsEvents.openSlideshow} 
                    // onTouchEnd={albumOptionsEvents.openSlideshow}> */}
                    <span className="menu_icon icon-icon_slideshow"></span> 
                    { config.slideShowText } 
                </a>
            </li>
            <li role="none" className="delete-album" style={{display: config.displayDeleteAlbumsOption}} name="av_delete_album" onClick={openDeleteModel} onTouchStart={openDeleteModel}  >
                <a role="menuitem" tabIndex="-1" href ="#" onClick={(e) => {e.preventDefault(e)}} aria-label={`${config.deleteAlbumText} ${ photoOrg.translations.photos["aria_label"]["opens_dialog"]}`}>
                    <span className="menu_icon icon-icon_delete_outline"></span> 
                    { config.deleteAlbumText } 
                </a>
            </li>

            {
                (showTopToolTip.current) ? (
                <li className="menu-position-top">
                    <span className="sf-pointer sf-pointer-top"></span>
                </li>)
                :null
            }

        </ul>
        {
            ReactDOM.createPortal(
            <div  role="dialog" id="rdeleteConfirmation" dialog-name="delete_album_warning" className="reveal-modal" data-reveal data-reveal-listen aria-labelledby="deleteHeader" aria-modal="true">
                    <div className="confirmation-body">
                        <div id="deleteHeader" className="confirmation-header confirm-header-nobg">
                            <h2>{photoOrg.translations.photos["delete_album_warning"]}</h2>
                        </div>
                        <div className="confirmation-wrapper">
                            <p id="deleteNote">{deleteConfirmationAlbumName}</p>
                            <div className="btn_wrapper">
                                <a href="#" fixfocus  button-name="cancel-button" className="pill-border cancel_button cancel-button omniture_btn" name="delete_layer_cancel" role="button" onClick={closeDeleteModel}>{photoOrg.translations.photos["action_container"]["Cancel"]}</a>
                                <a href="#" fixfocus  button-name="delete-button" className="pill delete_button delete-button omniture_btn" name="delete_layer_delete_button" role="button" onClick={deleteAlbum}>{photoOrg.translations.photos["action_container"]["Delete"]}</a>
                            </div>
                        </div>

                    <a href className="close-reveal-modal" name="delete_layer_cancel_icon" role="button" aria-label={photoOrg.translations.photos["aria_label"]["close_dialog"]} onClick ={closeDeleteModel} ></a>
                    </div>
            </div>, document.body)
        }
        </>
    );
}

export default AlbumsGearIconDropdown;
